// Module
var code = "<a href=\"#\" ng-click=\"dismiss()\" class=\"close\">Close</a> <i class=\"material-icons-outlined\">check_circle</i><h2 class=\"no-underline\"><strong>Offer</strong> Claimed</h2><p> A message has been sent to the owner of this offer. Someone will be in touch shortly to assist you with the redemption of this offer.</p>";
// Exports
module.exports = code;